
<template>
	<div class="comp">
		<el-dialog title="选择支付方式" width="500px" :visible="dialogState" @close="close" :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" :close-on-click-modal="false">
			<div class="loginPanel">
				<img class="img" @click="select(1)" src="../../../assets/img/order/weixin.png"/>
				<img class="img" @click="select(2)" src="../../../assets/img/order/zhifubao.png"/>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let Base64 = require('js-base64').Base64
	export default {
		data() {
			return {
				dialogState:true,
				
			}
		},
		mounted(){
		},
		methods:{
			close(){
				this.$emit("submit",{type:'close'})
			},
			select(num){
				this.$emit("submit",{type:'success',data:num})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		.loginPanel{
			text-align: center;padding:0 0 20px 0;
			.img{
				width:300px;padding:30px;
			}
		}
	}
</style>
